import React from 'react'
import { UIBadge, type UIBadgeProps } from './ui-badge'
import { cn } from '../../lib/utils'

export interface UIBadgeGradientProps extends Omit<UIBadgeProps, 'children'> {
  children?: React.ReactNode
  gradientFrom?: string
  gradientTo?: string
}

/**
 * UIBadgeGradient - Gradient Badge Block
 * 그라디언트 배경의 배지 컴포넌트입니다.
 * 그라디언트 배경의 배지입니다.
 */
export const UIBadgeGradient = React.forwardRef<HTMLSpanElement, UIBadgeGradientProps>(
  ({
    children = "Gradient",
    gradientFrom = "from-sky-500",
    gradientTo = "to-indigo-600",
    className,
    ...props
  }, ref) => {
    return (
      <UIBadge
        ref={ref}
        shape="pill"
        className={cn(
          "border-none bg-gradient-to-r text-white",
          gradientFrom,
          gradientTo,
          className
        )}
        {...props}
      >
        {children}
      </UIBadge>
    )
  }
)

UIBadgeGradient.displayName = "UIBadgeGradient"